/**
 * Consulting price sheet. The consulting page, JSON-LD, and llms.txt follow these
 * amounts. The 60-minute consult price is intentionally not in this module:
 * it stays on the consult page and out of structured data.
 */
export const consultingPrices = {
  aiSdlcAssessment: 2500,
  advisorMonthly: 3500,
  coreMonthly: 6000,
  embeddedMonthly: 9500,
  aiAssistant: 1500,
  smartSearch: 1000,
  leadAutomation: 1000,
  aiStarterMonthly: 29,
  aiStarterChats: 150,
  aiStandardMonthly: 79,
  aiStandardChats: 600,
  aiProMonthly: 199,
  aiProChats: 2000,
  extraChat: 0.1,
  quickStartAudit: 750,
  automationMin: 3000,
  automationMax: 5000,
  llmAppMin: 5000,
  llmAppMax: 10000,
  agentFrom: 12000,
  buildRetainerMonthly: 5000,
  hourly: 150,
  hourlyMinimumHours: 4,
  supportMinMonthly: 300,
  supportMaxMonthly: 1000,
} as const;

export function usd(amount: number, fractionDigits = 0): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}

export const consultingPriceLabels = {
  assessment: usd(consultingPrices.aiSdlcAssessment),
  advisor: usd(consultingPrices.advisorMonthly),
  core: usd(consultingPrices.coreMonthly),
  embedded: usd(consultingPrices.embeddedMonthly),
  aiAssistant: usd(consultingPrices.aiAssistant),
  smartSearch: usd(consultingPrices.smartSearch),
  leadAutomation: usd(consultingPrices.leadAutomation),
  aiStarter: usd(consultingPrices.aiStarterMonthly),
  aiStandard: usd(consultingPrices.aiStandardMonthly),
  aiPro: usd(consultingPrices.aiProMonthly),
  extraChat: usd(consultingPrices.extraChat, 2),
  quickStart: usd(consultingPrices.quickStartAudit),
  automation: `${usd(consultingPrices.automationMin)} to ${usd(consultingPrices.automationMax)}`,
  llmApp: `${usd(consultingPrices.llmAppMin)} to ${usd(consultingPrices.llmAppMax)}`,
  agentFrom: `From ${usd(consultingPrices.agentFrom)}`,
  retainer: `${usd(consultingPrices.buildRetainerMonthly)} / mo`,
  hourly: `${usd(consultingPrices.hourly)} / hr`,
  hourlyShort: usd(consultingPrices.hourly),
  support: `${usd(consultingPrices.supportMinMonthly)} to ${usd(consultingPrices.supportMaxMonthly)} / mo`,
  aiUsage: "Provider cost plus 50%",
} as const;
